import React from 'react'
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import { useDispatch, useSelector } from "react-redux"
import { fetchAppStatus, getAppEnabled, getCanUseApp } from "../../../../Resources/Organization/Apps/AppsData.js"
import { useDataFetcherV2 } from "../../../Common/Data/useDataFetcher.js"
import RedirectTo from "../../../Common/RedirectTo.js"
import { trackButtonClicked } from "../../../Services/Analytics/TrackEventsService.js"
import { MAILCHIMP } from "../AppsData.js"
import { openPaywall } from "../Redux/Actions.js"

const MailchimpButton = () => {
  const [fetchingStatusComplete] = useDataFetcherV2(fetchAppStatus(MAILCHIMP))
  const appEnabled = useSelector(getAppEnabled(MAILCHIMP))
  const canUseApp = useSelector(getCanUseApp(MAILCHIMP))
  const dispatch = useDispatch()

  const submitSignUp = () => {
    RedirectTo.mailchimpLogin()
  }

  const properties = {
    app_name: 'mailchimp',
    category: 'marketing',
    pathname: window.location.pathname,
    url: window.location.href
  }

  const buttonText = () => {
    if (canUseApp && appEnabled) {
      return 'Launch Mailchimp'
    } else if (!appEnabled && canUseApp) {
      return 'Connect Mailchimp'
    } else if (!canUseApp) {
      return 'Upgrade'
    }
  }

  const handleAppButtonOnClick = () => {
    dispatch(trackButtonClicked(buttonText, properties))
    if (!canUseApp) {
      dispatch(openPaywall())
    } else {
      submitSignUp()
    }
  }

  return (
    fetchingStatusComplete &&
      <Button
        variant="contained"
        color="primary"
        onClick={handleAppButtonOnClick}
      >
        {buttonText()}
      </Button>
  )
}
export default MailchimpButton
